import { z } from 'zod';
import i18next from 'i18next';
import { translatedCheckPointSchema } from '../translated-check-point/translated-check-point.schema';

export const NOT_AUTOMATIC_VALIDATION_CHECK_POINT_TIMEOUT_DEFAULT_VALUE = 60;

export const checkPointSchema = z.object({
  id: z.string().optional(),
  reportIcon: z
    .string()
    .superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('checkPoint:reportIconRequired'),
        });
      }
    })
    .default(''),
  appIcon: z
    .string()
    .superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('checkPoint:appIconRequired'),
        });
      }
    })
    .default(''),
  appSketch: z.string().nullish(),
  appVideo: z.string().nullish(),
  name: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('checkPoint:checkPointNameRequired'),
      });
    }
  }),
  type: z
    .string()
    .superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('checkPoint:checkPointTypeRequired'),
        });
      }
    })
    .default(''),
  description: z.string().nullish(),
  outOfServiceDescription: z.string().nullish(),
  checkDistance: z.boolean().default(false),
  enableSound: z.boolean().default(false),
  withEquipmentDetection: z.boolean().default(true),
  videoDuration: z
    .union([z.string(), z.number()])
    .transform((val) => parseInt(val as string, 10))
    .nullish(),
  detectedEquimentTimeout: z
    .union([z.string(), z.number()])
    .transform((val) => parseInt(val as string, 10))
    .nullish(),
  undetectedEquimentTimeout: z
    .union([z.string(), z.number()])
    .transform((val) => parseInt(val as string, 10))
    .nullish(),
  notAutomaticValidationCheckPointTimeout: z
    .union([z.string(), z.number()])
    .transform((val) => parseInt(val as string, 10))
    .default(NOT_AUTOMATIC_VALIDATION_CHECK_POINT_TIMEOUT_DEFAULT_VALUE),
  percentOptionalEquipmentDetection: z
    .union([z.string(), z.number()])
    .transform((val) => parseInt(val as string, 10))
    .nullish(),
  identifiableEquipmentIds: z.array(z.string()).nullish(),
  requiredEquipmentIds: z.array(z.string()).nullish(),
  optionalEquipmentIds: z.array(z.string()).nullish(),
  orderedEquipments: z
    .array(z.object({ id: z.string(), index: z.number() }))
    .nullish(),
  enableLicensePlateDetection: z.boolean().default(false),
  enablePlateCorrection: z.boolean().default(false),
  enableVINDetection: z.boolean().default(false),
  enableVINCorrection: z.boolean().default(false),
  enableRegistrationCertificate: z.boolean().default(false),
  canBeSkipped: z.boolean().default(false),
  isFrontPart: z.boolean().default(false),
  isBackPart: z.boolean().default(false),
  isLeftPart: z.boolean().default(false),
  isRightPart: z.boolean().default(false),
  translatedCheckPoints: z.array(translatedCheckPointSchema).nullish(),
  active: z.boolean().default(true),
});

export type TCheckPointSchema = z.infer<typeof checkPointSchema>;
